import { useEffect } from 'react';
import { useProperty } from '@eti/providers';

const useKindly = () => {
  const { p } = useProperty();
  useEffect(() => {
    const kindlyElementId = 'kindly-script-tag';
    const isKindlyEnabled = p('IbeClient.Kindly.Enabled');

    if (isKindlyEnabled) {
      const scriptElement = document.createElement('script');
      const kindlyId = p('IbeClient.Kindly.Id');
      const src = `https://cdn.spinnaker-js.com/rc/${kindlyId}/scripts/s.js`;

      const attributes = {
        type: 'text/javascript',
        src,
        id: kindlyElementId,
        'data-testid': 'kindly-script-tag',
      };

      const setMultipleAttributes = (element) => {
        for (const [key, value] of Object.entries(attributes)) {
          element.setAttribute(key, value);
        }
      };

      setMultipleAttributes(scriptElement);
      document.body.appendChild(scriptElement);
    }
    return () => {
      const kindlyElement = document.getElementById(kindlyElementId);
      if (kindlyElement) {
        document.body.removeChild(kindlyElement);
      }
    };
  }, [p]);
};

export { useKindly };
